import fetch from '@/axios/promise'
import {DORM_URL} from '@/config/constant'
/**************************费用信息***********************************/
export const FILE_URL = 'http://172.119.0.13:8001'
export const InvoiceRise='北京福通聚远科技有限公司'
export const InvoiceNumber='91110113MA00BL4E4Q'
//保存费用
export function createCostInfo (query) {
  return invoke(query, '/expense/createCostInfo', 'POST')
}
// 获取费用类型
export function costTypeSelectList (query) {
  return invoke(query, '/expense/costTypeSelectList', 'POST')
}
// 获取费用类型详细信息costTypeSelect
export function costTypeSelect (query) {
  return invoke(query, '/expense/costTypeSelect', 'POST')
}
// 保存费用
export function saveCost (query) {
  return invoke(query, '/expense/saveCost', 'POST')
}
// 查看费用列表
export function selectCostList (query) {
  return invoke(query, '/expense/selectCostList', 'POST')
}
// 根据费用编号过滤
export function selectCostListNumb (query) {
  return invoke(query, '/expense/selectCostList', 'POST')
}
// 跳转费用详情
export function selectCostDetail (query) {
  return invoke(query, '/expense/selectCost', 'POST')
}
// 修改费用 insertCost
export function insertCost (query) {
  return invoke(query, '/expense/insertCost', 'POST')
}
// 查询可以使用的费用 selectMainIdCostList
export function selectMainIdCostList (query) {
  return invoke(query, '/expense/selectMainIdCostList', 'POST')
}
export function uploadCostImg (query) {
  return invoke(query, '/expense/uploadCostImg', 'POST')
}
// 查询数据字典
export function selectDictionType (query) {
  return invoke(query, '/expense/selectDictionType', 'POST')
}
// 根据提供的发票照片返回发票信息 getInvoceInfo
export function getInvoceInfo (query) {
  return invoke(query, '/expense/invoce/discern', 'POST')
}
// 查看发票列表 selectFillList
export function selectFillList (query) {
  return invoke(query, '/expense/selectFillList', 'POST')
}
//删除费用
export function deleteCost (query) {
  return invoke(query, '/expense/deleteCost', 'POST')
}
//逻辑删除滴滴
export function deleteDIDI (query) {
  return invoke(query, '/expense/deleteDIDI', 'POST')
}
/** ****************************报销单********************************/
// 报销单列表
export function selectAxpeAccolist (query) {
  return invoke(query, '/reimburse/selectAxpeAccolist', 'POST')
}
// 报销单详情
export function selectExpeAcco (query) {
  return invoke(query, '/reimburse/selectExpeAcco', 'POST')
}
// 报销单保存
export function saveReExpeAcco (query) {
  return invoke(query, '/reimburse/saveReExpeAcco', 'POST')
}
// 取消报销单于费用的关联
export function clearCostRelation (query) {
  return invoke(query, '/reimburse/clearCostRelation', 'POST')
}
//修改报销单状态 updateExpeAccoStatus
export function updateExpeAccoStatus(query) {
  return invoke(query,'/reimburse/updateExpeAccoStatus','POST');
}
//删除报销单以及清空费用mainId
export function deleteReim(query) {
  return invoke(query,'/reimburse/deleteReim','POST');
}
//修改报销单
export function updateReimburse(query) {
  return invoke(query,'/reimburse/updateReimburse','PUT')
}

/******************发票类型********************/
// 获取所有的发票类型数据
export function getInvoTypeList(query) {
  return invoke(query,'/expense/getInvoTypeList','GET');
}

function invoke (query, url, method) {
  return fetch({
    url: DORM_URL + url,
    method: method,
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/rem/cost/cost.js